let utils = require('../../../actions/utils');
let content = require('../../../actions/layout/content');
let account = require('../../../actions/account');
let userGroup = require('../../groups/user');
let layoutGroup = require('../../groups/layout');
let orders = require('../../../actions/account/orders');
let usersList = require('../../../actions/account/users-list');
let userForm = require('../../../actions/account/user-form');
let users = require('../../../actions/account/users');
let analytics = require('../../../actions/analytics');
let seo = require('../../../actions/seo');
let registration = require('../../../actions/auth/registration');
let error = require('../../../actions/error');

module.exports = [
    analytics.parseUtmFromQuery,
    ...userGroup.checkAuthCookie([
        ...userGroup.getUser
    ]),
    ...userGroup.access('manager', [
        utils.set('layout', 'main'),
        utils.setFromArgsToState('subPage', 'page.sub'),
        ...layoutGroup.setMainLayoutBlocks,
        [
            registration.getCountries, {
                success: [
                    utils.setFromArgsToState('countries', ['account', 'userForm', 'countries'])
                ],
                error: [ error.internalError('manager.users.getCountries') ]
            }
        ],
        seo.setDashboardMeta('Панель менеджера - Библиотека данных', 'Панель менеджера'),
        content.setComponentsByLink,
        account.setComputedFields,
        usersList.setComputedFields,
        [
            orders.getUsers,
            {
                success: [
                    utils.setFromArgsToState('users', ['account', 'users', 'list', 'data']),
                    userForm.setComputedFields
                ],
                error: []
            }
        ],
        [
            usersList.isUserSelected,
            {
                yes: [
                    utils.set(['account', 'users', 'selectedUserIsLoading'], true),
                    [
                        users.getUser,
                        {
                            success: [
                                userForm.setDefaultCountry,
                                userForm.initUserForm
                            ],
                            error: [
                            ]
                        }
                    ],
                    utils.set(['account', 'users', 'selectedUserIsLoading'], false)
                ],
                no: []
            }
        ],
        analytics.pageview
    ])
];



// WEBPACK FOOTER //
// ./signals/pages/manager/users.js